/* unplugin-vue-components disabled */import { render } from "./popupRules.vue?vue&type=template&id=f9445574&scoped=true"
import script from "./popupRules.vue?vue&type=script&lang=js"
export * from "./popupRules.vue?vue&type=script&lang=js"

import "./popupRules.vue?vue&type=style&index=0&id=f9445574&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9445574"]])

export default __exports__